export const sendEvent = (name, parameters) => {
  if (typeof gtag === 'undefined') return;

  gtag('event', name, parameters);
};
